// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QjaJm","index":"styles_index__2Nzx-"};